import CheckboxFilter from "../Common/CheckboxFilter";
import { transmissionData } from "../../../../data/category/inputData";

const Transmission = () => {
  return (
    <CheckboxFilter
      title={"Transmission"}
      filterData={transmissionData}
      filterName={"transmission"}
    />
  );
};

export default Transmission;
